import { useQuery } from '@tanstack/react-query';
import { useApi } from '@tymely/api';

import { PolicyResponse } from '../types';

interface UsePolicyNodeParams {
    organizationId: string | number;
    policySetId?: string | number;
    nodeId?: string | number;
}

export const usePolicyNode = ({ organizationId, policySetId, nodeId }: UsePolicyNodeParams) => {
    const api = useApi();

    return useQuery({
        queryKey: ['policyNode', organizationId, policySetId, nodeId],
        queryFn: async () => {
            if (!policySetId || !nodeId) return null;

            const response = (await api.get('policies/search', {
                params: {
                    organization_id: organizationId,
                    policy_set_id: policySetId,
                },
            })) as unknown as PolicyResponse;

            return response?.graph?.nodes?.find((n: { id: string | number }) => n.id === nodeId);
        },
        enabled: Boolean(policySetId && nodeId),
    });
};
